import { TextareaHTMLAttributes, forwardRef } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  hint?: string
  error?: string
  example?: string
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ label, hint, error, example, className = '', id, ...rest }, ref) => {
    const fieldId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
    return (
      <>
        <div className={`field ${error ? 'field--error' : ''} ${className}`}>
          {label && <label className="field-label" htmlFor={fieldId}>{label}</label>}
          {example && <p className="field-example">e.g. {example}</p>}
          <textarea ref={ref} id={fieldId} className="textarea" {...rest} />
          {hint && !error && <p className="field-hint">{hint}</p>}
          {error && <p className="field-error-msg">{error}</p>}
        </div>

        <style>{`
          .textarea {
            width: 100%;
            padding: 9px 12px;
            background: var(--bg-input);
            border: 1px solid var(--border);
            border-radius: var(--radius-md);
            color: var(--text-primary);
            font-size: 0.875rem;
            font-family: var(--font-sans);
            resize: vertical;
            min-height: 80px;
            transition: border-color 0.15s;
            outline: none;
            line-height: 1.6;
          }
          .textarea:focus { border-color: var(--accent); }
          .textarea::placeholder { color: var(--text-muted); }
          .field--error .textarea { border-color: var(--color-error); }
        `}</style>
      </>
    )
  }
)
Textarea.displayName = 'Textarea'
